export default __webpack_public_path__ + "static/media/Sunday_03.8bcadbf2.png";